import { defineStore } from 'pinia'

import { state, actions, getters } from "./modules/book";

const store = defineStore('main', {
  state,
  actions,
  getters,
  persist: [
      {
        pick: ['customer'],
        storage: localStorage,
        beforeHydrate: (ctx) => {
          console.log(`about to hydrate customer localStorage '${ctx.store.$id}'`)
        }
      },
      {
        pick: ['items'],
        storage: sessionStorage,
        beforeHydrate: (ctx) => {
          ctx.store.clearPrices()
          console.log(`about to hydrate items sessionStorage '${ctx.store.$id}'`)
        }
      },
  ],
});


export default store;